import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";

type Props = {
    title?: string;
    message: string;
    acceptTitle?: string;
    cancelTitle?: string;
    acceptFn: (passthroughData?: any) => void;
    cancelFn: () => void;
    passthroughData?: any;
    outerClassName?: string;
};

export const OwContinueConfirmModal = (props: Props) => {
    const accept = () => {
        props.acceptFn(props.passthroughData);
    };

    return (
        <div className={"OwContinueConfirmModal p-4 " + (props.outerClassName || "")}>
            <div className="text-center">
                {props.title ? (
                    <div className="mt-3">
                        <OwTitle title={props.title} tag={"h3"} />
                    </div>
                ) : null}
            </div>

            <div className="mt-5 text-center">
                <div>
                    <OwLabel title={props.message} />
                </div>
            </div>

            <div className={"mt-5 text-center"}>
                <OwButton title={props.acceptTitle || "ok"} fn={accept} />
                <OwButton title={props.cancelTitle || "cancel"} fn={props.cancelFn} className={"text-danger ms-2"} />
            </div>
        </div>
    );
};
